var initObj = {
  sex: ['men', 'women'],
  age: {
    low: 18,
    high: 90,
  },
  region: [],
  date: null,
  keyword: '',
};

export function lsPostConditionInit() {
  localStorage.setItem('PostCondition', JSON.stringify(initObj));
}

export function lsPostConditionInitCheck() {
  let lsObj = JSON.parse(localStorage.getItem('PostCondition'));

  if (JSON.stringify(initObj) === JSON.stringify(lsObj)) {
    return true;
  }
  else {
    return false;
  }
}
